export const STATUS_MACHINE_OPTIONS = [
  { value: "", label: "Selecciona una opción" },
  { value: "all", label: "Todas las máquinas" },
  { value: "stopped", label: "Máquinas no al día" },
  { value: "uptodate", label: "Máquinas al día" },

  { value: "centrifuga", label: "Centrífuga" },
  { value: "cotherm2comp", label: "CoTherm 2Comp" },
  { value: "cotherm4comp", label: "CoTherm 4Comp" },
  { value: "cotherm4comp2cc", label: "CoTherm 4Comp 2CC" },
  { value: "ezchiller2comp", label: "ezChiller 2Comp" },
  { value: "ezchiller2compct6", label: "ezChiller 2Comp CT6" },
  { value: "fsc", label: "Full Service Cooling" },
  { value: "fsc_1comp", label: "Full Service Cooling 1Comp" },
  { value: "fsc_unico", label: "Full Service Cooling UNICO" },
  { value: "fsc_v2_1comp", label: "Full Service Cooling V2 1Comp" },
  { value: "fsc_v3", label: "Full Service Cooling V3" },
  { value: "fsc_v3_1comp", label: "Full Service Cooling V3 1Comp" },
  { value: "licuador1comp", label: "Licuador 1Comp" },
  { value: "optichiller1comp", label: "Optichiller 1Comp" },
  { value: "optichiller1comp_ct6", label: "Optichiller 1Comp CT6" },
  { value: "optichiller2comp", label: "Optichiller 2Comp" },
  { value: "optichiller_ct6", label: "Optichiller 2Comp CT6" },
  { value: "victex1comp", label: "Victex 1 Compresor" },
];